import React, { createContext, useContext, useState, useEffect } from 'react';
import authService from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [admin, setAdmin] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        checkAuthStatus();
    }, []);

    const checkAuthStatus = () => {
        try {
            const isAuth = authService.isAuthenticated();
            const adminData = authService.getAdminData();
            
            setIsAuthenticated(isAuth);
            setAdmin(adminData);
        } catch (error) {
            console.error('Auth check error:', error);
            setIsAuthenticated(false);
            setAdmin(null);
        } finally {
            setIsLoading(false);
        }
    };

    const login = async (username, password) => {
        try {
            const result = await authService.login(username, password);
            
            if (result.success) {
                setIsAuthenticated(true);
                setAdmin(result.admin);
            }
            
            return result;
        } catch (error) {
            console.error('Login error:', error);
            return {
                success: false,
                message: 'Login failed. Please try again.'
            };
        }
    };

    const logout = () => {
        authService.logout();
        setIsAuthenticated(false);
        setAdmin(null);
    };

    const value = {
        isAuthenticated,
        admin,
        isLoading,
        login,
        logout,
        checkAuthStatus
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};
